var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "va-card",
        { staticClass: "pa-0" },
        [
          _c(
            "div",
            { staticClass: "pa-4 border-b", staticStyle: { width: "100%" } },
            [
              _c("h3", { staticClass: "font-bold" }, [
                _vm._v(" " + _vm._s(_vm.$t("software.magoForDisplay")) + " ")
              ])
            ]
          ),
          _c(
            "v-row",
            { staticClass: "pa-0 ma-0" },
            _vm._l(_vm.links, function(link) {
              return _c(
                "v-col",
                {
                  key: link.id,
                  staticClass:
                    "\n          version-cell\n          border-r\n          pa-4\n          d-flex\n          flex-column\n          align-center\n          justify-center\n        ",
                  attrs: { cols: "12", lg: "3" }
                },
                [
                  _c("h4", { staticClass: "mb-2" }, [
                    _vm._v(_vm._s(link.title))
                  ]),
                  _c("a", { attrs: { href: link.url, target: "_blank" } }, [
                    _c("img", {
                      attrs: { height: "40", src: link.banner, alt: link.title }
                    })
                  ])
                ]
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }